import * as aspSettings from './aspSettings';
import * as aspObjects from './aspObjects';
import * as enums from '../common/enums';
import * as settings from '../common/settings';
import { AspObject } from './AspObject';
import { IObjectsDrawer } from './interfaces';
import { DisplayObject } from './DisplayObject';
import { PlotCoreObject } from './PlotCoreObject';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

let i: number = 0;

export class PlotDisplayCoreObject extends DisplayObject {

  displaySymbol: boolean;
  firstDisplay: boolean = true;
  isCorrelated: boolean = false;
  opacity: number = 1;

  constructor(aspObject: AspObject, drawer: IObjectsDrawer) {
    super(aspObject, drawer);

    this.displaySymbol = settings.userSettings.plotDisplaySymbol;
  }

  public get sensorID(): number {
    let plotObject = this.aspObject as PlotCoreObject;
    return plotObject.sensorID;
  }

  public get sensorPlotID(): number {
    let plotObject = this.aspObject as PlotCoreObject;
    return plotObject.plotID;
  }

  public get slotNumber(): number {
    let plotObject = this.aspObject as PlotCoreObject;
    return plotObject.slotNumber;
  }

  // Override DisplayObject
  onDataChange(): void {
    let plotObject = this.aspObject as PlotCoreObject;

    // if (this.firstDisplay) {
    this.setColor();
    super.onDataChange();
    // this.isCorrelated = plotObject.isCorrelated;
    // }
  }

  private getOpacity() : number {
    let plotObject = this.aspObject as PlotCoreObject;
    let age = aspObjects.plotsPool.getSlotAge(plotObject.slotNumber);
    age = (settings.userSettings.plotTrailLength - age) / settings.userSettings.plotTrailLength;
    age = Number.parseFloat(age.toExponential(1));
    return age;
  }

  private setColor() {
    let plotObject = this.aspObject as PlotCoreObject;
    let color = aspSettings.colorOfPlot(plotObject.CorrelationType, this.opacity);
    this.drawData[plotObject.objectType].colors = [color, color, null]; // per template
  }

  protected updateDrawValues() {
    // should arrive here just once, call prepareToDraw() since it may not be called if plots are not displayed
    this.prepareToDraw();
  }

  // Override DisplayObject
  protected hookedTemplateIndex(): number {
    return 2;
  }


  // Override DisplayObject
  protected prepareToDraw() {
    // check filtering
    if (!this.isVisible())
      return;

    // get the real object with all the data
    let plotObject = this.aspObject as PlotCoreObject;

    let update = false;

    let displaySymbol = settings.userSettings.plotDisplaySymbol
    if (this.displaySymbol != displaySymbol){
      this.displaySymbol = displaySymbol; // get flag if the plot is displayed as a symbol or letter
      update = true;
    }

    let opa = this.getOpacity();
    if (this.opacity != opa){
      this.opacity = opa;
      this.setColor();
      update = true;
    }

    // get the symbol from the track
    let symbol = displaySymbol ?
      [plotObject.symbol] : undefined;
    // let symbol = [plotObject.Symbol];
    // get the letter from the track
    let letter = displaySymbol ?
      undefined : plotObject.sensorLetter;
    // check if hooked
    let hook = aspSettings.selectedIds.has(plotObject.id) ? ['hook-circle'] : null;
    // set it all up
    this.drawData[plotObject.objectType].values = [ // per template
      symbol,
      letter,
      hook
    ];

    // this.firstDisplay = false;
    this.displaySymbol = displaySymbol;

    // check if the obj is already in dm if so we do not recreate it...
    if (!this.drawer.getObject(this.id))
      this.drawer.addObjectToDm(this);

    if (update)
      this.drawer.updateObjectInDm(this);
  }

  // Override DisplayObject
  isVisible() {
    if (!super.isVisible())
      return false;
    if (!this.aspObject.active())
      return false;
    if (settings.userSettings.plotSourcesHidden.has(this.sensorID))
      return false;
    let age = aspObjects.plotsPool.getSlotAge(this.slotNumber);
    if (age > settings.userSettings.plotTrailLength)
      return false;

    let plotObject = this.aspObject as PlotCoreObject;
    let i = 0;
    let res = true;
    settings.userSettings.plotTypeHidden.forEach(bool => {
      if (plotObject.CorrelationType == i && !bool) {
        res = false;
      }
      i++;
    })
    return res;
  }
}
